import { Target, Shield, Users, Zap, BarChart3, HeartHandshake } from 'lucide-react'
import { motion } from 'framer-motion'

const values = [
  {
    icon: Target,
    title: 'Radical Accountability',
    description: 'We own results, not excuses. Every strategy has a measurable outcome, and we report on it honestly — even when the numbers are uncomfortable.',
  },
  {
    icon: Shield,
    title: 'Uncompromising Integrity',
    description: "We'll tell you what you need to hear, not what you want to hear. If a channel isn't working, we say so. If your budget is better spent elsewhere, we'll recommend it.",
  },
  {
    icon: Users,
    title: 'Client Obsession',
    description: "Your goals are our goals. We don't disappear after onboarding — we embed in your business, learn your market, and treat your growth like our own.",
  },
  {
    icon: Zap,
    title: 'Bias for Action',
    description: 'Analysis paralysis kills momentum. We move fast, test early, and iterate relentlessly. Perfect is the enemy of shipped.',
  },
  {
    icon: BarChart3,
    title: 'Data Over Ego',
    description: "Opinions are cheap. We let the data decide — what to scale, what to kill, and where to double down. Every decision is backed by evidence, not gut feel.",
  },
  {
    icon: HeartHandshake,
    title: 'Partnership, Not Servitude',
    description: "We're not order-takers. We challenge assumptions, push back on bad ideas, and collaborate as equals. The best work comes from mutual respect.",
  },
]

export default function Values() {
  return (
    <section className="py-24 md:py-32 bg-white border-t border-slate-200">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold text-accent uppercase tracking-[0.2em] mb-6">Our Values</h2>
          <h3 className="text-4xl md:text-6xl font-bold font-heading text-primary uppercase tracking-tight leading-[0.95]">
            What We <span className="text-accent">Stand For.</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-5xl mx-auto">
          {values.map((value, i) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-accent/10 mb-5">
                <value.icon className="w-6 h-6 text-accent" strokeWidth={1.5} />
              </div>
              <h4 className="text-lg font-bold font-heading text-primary uppercase tracking-tight mb-2">
                {value.title}
              </h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
